import { BrowserRouter, Route, Routes } from "react-router-dom"
import WorkflowFileExplorer from "../WorkflowFileExplorer/WorkflowFileExplorer"
import AnalysisDashboard from "../Analysis/AnalysisDashboard"

/**
 * Navigation is responsible for handling the navigation routes for each page of the application.
 */
const Navigation = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WorkflowFileExplorer />} />
        <Route path="/workflow" element={<AnalysisDashboard />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Navigation